import { generateUuidV4Regex } from "@/common/helpers/utils";
import { RelocationOrderDetailView } from "@/views/relocation-order-detail/relocation-order-detail.view";
import { Redirect, Route, Switch } from "wouter";
import { NewDateView } from "./new-date/new-date.view";
import { RelocationRequestView } from "./relocation-request.view";

export function RelocationRequestRoutes() {
  const relocationRequestUuidSetPickupDateRegex = generateUuidV4Regex({
    paramName: "uuid",
    suffix: "/set-pickup-date",
  });
  const relocationOrderUuidRegex = generateUuidV4Regex({
    paramName: "uuid",
  });

  return (
    <Switch>
      <Route path={relocationRequestUuidSetPickupDateRegex} component={NewDateView} />
      <Route path={relocationOrderUuidRegex} component={RelocationOrderDetailView} />
      <Route path="/" component={RelocationRequestView} />
      <Redirect to="/" replace />
    </Switch>
  );
}
